import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { AppSettingValue, ReadAppSetting } from "@/types/appSettings";

const AppSettingsServiceAPI = new APIService<ReadAppSetting>(API.AppSettings);

export const AppSettingsService = {
  getSettings: () =>
    AppSettingsServiceAPI.get<{ items: ReadAppSetting[]; count: number }>(),
  updateSetting: (code: string, value: AppSettingValue) =>
    AppSettingsServiceAPI.patch(code, { value }),
};
